/**
 * GlobalSEOMeta — fetches the admin-configured Google Search Console
 * verification token + global JSON-LD Organization data and injects them
 * into <head> via react-helmet-async on every page.
 */
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const GlobalSEOMeta = () => {
  const [metaToken, setMetaToken] = useState('');

  useEffect(() => {
    let cancelled = false;
    axios.get(`${BACKEND_URL}/api/seo/gsc-meta`)
      .then(({ data }) => {
        if (!cancelled) setMetaToken((data?.meta_token || '').trim());
      })
      .catch(() => { /* gracefully ignore — verification is optional */ });
    return () => { cancelled = true; };
  }, []);

  return (
    <Helmet>
      {metaToken && (
        <meta name="google-site-verification" content={metaToken} />
      )}
      {/* Site-wide Organization JSON-LD so search engines understand the brand
          regardless of which page they land on first. */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "BeeWeddy",
          "url": BACKEND_URL,
          "logo": `${BACKEND_URL}/beeweddi-logo.png`,
          "sameAs": [],
          "description": "Wedding, birthday & event vendor marketplace with instant pricing for venues, photographers, decorators, caterers and more.",
        })}
      </script>
    </Helmet>
  );
};

export default GlobalSEOMeta;
